/**
 * Format a money value as USD `$0.00`.
 *
 * Backend returns money as DECIMAL strings for stored entities (house-account
 * balances/items, misc-ledger amounts) and as numbers for the Shift Summary
 * aggregation. This helper accepts both and parses/formats defensively, always
 * returning a 2-decimal `$0.00` string. A non-finite/garbage input formats as
 * `$0.00` rather than throwing.
 *
 * Currency is hardcoded to USD to match the codebase's existing `Intl` usage.
 */
export function formatMoney(value: string | number | null | undefined): string {
  const n = typeof value === 'number' ? value : parseFloat(value ?? '0');
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(n) ? n : 0);
}
